import React from "react";
import style from "../Style.module.css";

const Pattern7 = ({ color = "#2F2F2F", size = 312 }) => {
  return (
    <svg
      className={style.svgBackground}
      width={size}
      height={"100%"} // คำนวณอัตราส่วน
      viewBox="10 10 282 326"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: "block",
        margin: "0 auto", // จัดให้อยู่ตรงกลาง
      }}
    >
      <path
        d="M269.534 96.5597H227.332V51.3926C227.332 9.18568 195.391 -25 155.955 -25C116.52 -25 84.5785 9.18568 84.5785 51.3926V96.5597H42.3769C2.94116 96.5597 -29 130.745 -29 172.952C-29 215.159 2.94116 249.345 42.3769 249.345H84.5785V294.607C84.5785 336.814 116.52 371 155.955 371C195.391 371 227.332 336.814 227.332 294.607V249.345H269.623C309.059 249.345 341 215.159 341 172.952C340.911 130.745 308.97 96.5597 269.534 96.5597Z"
        fill={color}
        opacity={0.1}
      />
    </svg>
  );
};

export default Pattern7;
